import * as React from 'react';
import { datadogRum } from '@datadog/browser-rum';
import LandingPage from '../components/LandingPage/LandingPage';
import ApplyOnlineLayoutSimple from '../components/ApplyOnlineLayoutSimple/ApplyOnlineLayoutSimple';
import { AppContext } from '~/contexts/appContext';
import { documentUrls } from '~/helpers/urlHelper';
import { useTrack } from '~/hooks/track';
import { EventsNames } from '~/enums/Events';

export default function LandingPageContainer(props) {
  const { isDiscountTire } = props;
  const appContext = React.useContext(AppContext);
  const { track } = useTrack();

  React.useEffect(() => {
    datadogRum.addAction(`page-view: landing-page${isDiscountTire ? '-discount-tire' : ''}`, {});

    track({ eventName: EventsNames.LandingPage });
    // /* eslint-disable react-hooks/exhaustive-deps */
  }, []);

  return (
    <ApplyOnlineLayoutSimple>
      <LandingPage {...{ ...props, ...documentUrls(appContext.retailer), isDiscountTire }} />
    </ApplyOnlineLayoutSimple>
  );
}
